<!-- No saved pay method -->
<div id="recurring" *ngIf="currentButton === -1">
    <div *ngIf="rules === undefined">
        <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
        <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
        <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
        <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
        <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
    </div>
    <div class="header">Recurring Payments &amp; Plans</div>

    <div  *ngIf="rules?.length == 0" class="header-plan-msg">
        <div class="message">
            You do not have any saved recurring plans yet.
        </div>
    </div>
    
    <div class="clearfix"></div>
    <div class="row" *ngIf="rules?.length > 0">
        <div class="col-md-6" *ngFor="let rule of rules">
            <div class="add-card-button added-detail show-details">
                <img *ngIf="rule.frequency.frequencyType == 'AUTO_PAY'" src="ui/assets/img/Autopay_Active.svg" class="cc-ach-side-icons left" />
                <img *ngIf="rule.frequency.frequencyType == 'PLAN'" src="ui/assets/img/PaymentPlan_Active.svg" class="cc-ach-side-icons left" />
                <div class="card-info">
                    {{LABEL_CUSTOMER}}: {{rule.account.accountNumber}}<br>
                    Start Date: {{rule.event.startDate | date: 'MM/dd/yyyy'}}<br>
                    Payment Method: {{rule.wallet.nickname | truncate : 10}}<br>
                    Payment Amount: {{rule.paymentIsFull ? 'Full Amount' : rule.amount | currency }}<br>
                    Frequency: {{rule.frequency.caption | truncate : 15}} <br>
                    {{rule.event.endEvent==0 ? 'End Date: ' + (rule.event.endDate | date:'MM/dd/yyyy') : 
                        (rule.event.endEvent==1  ? 'End Event: After '+rule.event.numberOfPayment+ (rule.event.numberOfPayment >1 ? ' Payments' : ' Payment') :
                        'Active until Cancelled')}}
                </div>
                <!-- Delete Icon -->
                <a class='btn' type="button">
	                <i class="fas fa-trash-alt delete-icon" aria-hidden="true" (click)="onDelete(rule, body)"
	                    placement="bottom left auto" container="body" ngbTooltip="{{rule.frequency.frequencyType == 'PLAN' ? 'Delete Payment Plan' : 'Delete Autopay'}}"
	                    *ngIf="rule.frequency.frequencyType == 'PLAN' ? paymentHubComponent?.defaultSettings?.admin : true"></i>
                </a>
                <!-- Edit-Icon Only for Auto-pays-->
                <a *ngIf="rule.frequency.frequencyType == 'AUTO_PAY'" class='btn' type="button">
                    <i class="fas fa-edit edit-icon" aria-hidden="true" (click)="onUpdate(rule)"
                       placement="bottom left auto" container="body" ngbTooltip="{{'Edit Autopay'}}" ></i>
                </a>
            </div>
        </div>
    </div>
    <div class="add-method-div">
        <div class="header">Create a New Recurring Plan</div>
        <div class="input-flex add-payment-method-margin-bottom">
            <div class="add-card-button wd-50 card-detail"  *ngIf="currentButton === -1"
            [hidden]="!paymentHubComponent?.defaultSettings?.settings.autopay" (click)=toggleButton(1,0)>
                <img src="ui/assets/img/Autopay_Selection.svg" class="cc-ach-icons"/>
                <div>Autopay</div>
            </div>
            <div class="add-card-button wd-50 account-detail"  *ngIf="currentButton === -1"
            [hidden]="!paymentHubComponent?.defaultSettings?.settings.paymentPlan || !paymentHubComponent?.defaultSettings?.admin" (click)=toggleButton(2,0)>
                <img src="ui/assets/img/PaymentPlan_Selection.svg" class="cc-ach-icons"/>
                <div>Payment Plan</div>
            </div>
        </div>
        <div class="recurring_message">
            Only one recurring payment rule can be active at any time for an account.
        </div>
        <div class="input-flex add-payment-method-margin-bottom">
            <div *ngIf="(autoPay == 1)" class="invalid-feedback">
                <div>A payment rule already exists</div>
            </div>
            <div *ngIf="(autoPay == 2)" class="invalid-feedback">
                <div>A payment rule already exists</div>
            </div>
        </div>
    </div>
</div>

<div id="DebitCard" *ngIf="walletType == 'card' || walletType == 'bank'">
    <img src="ui/assets/img/Line_Recurring_Step3.svg" class="tracker-img"/>
    <div *ngIf="walletType == 'card'" class="header">Enter Card Information</div>
    <div *ngIf="walletType == 'card'" class="accepted-methods">
        <img  src="ui/assets/img/VISA.svg" class="accepted-methods-img" />
        <img  src="ui/assets/img/Mastercard.svg" class="accepted-methods-img" />
        <img  src="ui/assets/img/Discover.svg" class="accepted-methods-img" />
        <img  src="ui/assets/img/American Express.svg" class="accepted-methods-img"/>
    </div>
    <div *ngIf="walletType == 'bank'"  class="header">Enter Bank Information</div>
    <div *ngIf="walletType == 'bank'" class="accepted-methods">
     <img src="ui/assets/img/ACH.svg" class="accepted-methods-img"/>
    </div>
    <div class="clearfix"></div>
    <div class="card-detail-div">
        <form class="frm-card add-card"
              (ngSubmit)="formCardSubmitted = true"
              novalidate> 
            <div class="form-group type1">
                <div class="label" [hidden]="walletType == 'bank'">Name on Card</div>
                <div class="label" [hidden]="walletType == 'card'">Name on Bank Account</div>
                <div id="ccName" class="form-input">
                </div>
                <div *ngIf="cardErr.checkname.flag" class="invalid-feedback">
                    <div>{{cardErr.checkname.msg}}</div>
                </div>
            </div>

            <div [hidden]="walletType == 'bank'" class="form-group">
                <div class="label">Card Number</div>
                <div id="ccNumber" class="form-input"></div>
                <div *ngIf="cardErr.ccnumber.flag" class="invalid-feedback">
                    <div>{{cardErr.ccnumber.msg}}</div>
                </div>
            </div>
            <div [hidden]="walletType == 'card'" class="input-flex">
                <div [hidden]="walletType == 'card'" class="form-group">
                    <div class="label">Routing Number</div>
                    <div id="routingNo" class="form-input"></div>
                    <div *ngIf="cardErr.checkaba.flag" class="invalid-feedback">
                        <div>{{cardErr.checkaba.msg}}</div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="label">Account Number</div>
                    <div id="acNumber" class="form-input"></div>
                    <div *ngIf="cardErr.checkaccount.flag" class="invalid-feedback">
                        <div>{{cardErr.checkaccount.msg}}</div>
                    </div>
                </div>
            </div>
            <div class="input-flex">
                <div [hidden]="walletType == 'bank'" class="form-group">
                    <div class="label">Expiration Date</div>
                    <div id="ccExp" class="form-input"></div>
                    <div *ngIf="cardErr.ccexp.flag" class="invalid-feedback">
                        <div>{{cardErr.ccexp.msg}}</div>
                    </div>
                </div>
                
                <div [hidden]="walletType == 'bank'" class="form-group">
                    <div class="label">CVV</div>
                    <div id="cvv" class="form-input"></div>
                    <div *ngIf="cardErr.cvv.flag" class="invalid-feedback">
                        <div>{{cardErr.cvv.msg}}</div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="label" [ngClass]="formCardSubmitted && [zipCode.invalid && zipCode.touched ? 'text-danger' : 'label control-label']">
                        ZIP Code
                    </div>
                    <div class="form-field-custom">
                        <input name="billing-postal" class="form-field-collect-js form-field" type="tel" placeholder="00000" maxlength="6"
                                [(ngModel)]="wallet.zipCode" #zipCode="ngModel" required pattern="^(?! )[A-Za-z0-9 ]+(?<! )$"
                                [ngClass]="{ 'is-invalid': zipCode.invalid && zipCode.touched }"
                                [disabled]="isDisabled" [minlength]="5" [maxlength]="7">
                    </div>
                    <div *ngIf="zipCode.invalid && zipCode.touched"
                            class="invalid-feedback">
                        <div *ngIf="zipCode.errors?.required">ZIP Code is required</div>
                        <div *ngIf="zipCode.errors?.pattern">Invalid ZIP Code</div>
                        <div *ngIf="zipCode.errors?.minlength">Minimum length is 5 digits</div>
                        <div *ngIf="zipCode.errors?.maxlength">Maximum length is 7 digits</div>
                    </div>
                </div>
                <div [hidden]="walletType == 'card'" class="form-group">
                    <div class="label">
                        Business Account
                    </div>
                    <div class="form-check form-check-inline">
                        <input name="businessAccount" id="achBusinessAcctYes" type="radio" [value]=true [(ngModel)]="achBusinessAccount">
                        <div class="input-group-append">
                            <span>Yes</span>
                        </div>
                    </div>
                    <div class="form-check form-check-inline">
                        <input name="businessAccount" id="achBusinessAcctNo" type="radio" [value]=false [(ngModel)]="achBusinessAccount">
                        <div class="input-group-append">
                            <span>No</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="input-flex">
                <div class="form-group bottom-m-br">
                    <div class="label"
                        [ngClass]="nickname.invalid && nickname.touched ? 'text-danger' : 'label control-label'">
                        Payment Method Nickname
                    </div>
                    <div class="form-field-custom">
                        <input name="nickname" class="form-field-collect-js form-field" minlength="1" maxlength="20" 
                            [(ngModel)]="wallet.nickname" #nickname="ngModel" placeholder="Nickname"
                            pattern="^(?! )[A-Za-z0-9 ]+(?<! )$" required>
                    </div>
                    <div *ngIf="nickname.invalid && nickname.touched"
                         class="invalid-feedback" style="display: block">
                         <div *ngIf="nickname.errors?.required">Nickname is required</div>
                         <div *ngIf="nickname.errors?.pattern">Invalid Nickname</div>
                         <div *ngIf="nickname.errors?.minlength">Minimum length of 1 character</div>
                         <div *ngIf="nickname.errors?.maxlength">Maximum length of 20 characters</div> 
                    </div>
                </div>         
            </div>
            <div class="sub-div">
                <div class="back-button" (click)="toggleWallet('back');" >
                    <i class="fas fa-chevron-left"></i>
                </div>
                <button *ngIf="!onSubmitLoader" id="collectJsSubmissionTrigger" (click)=displayLoadingImage() class="btn submit-button" [disabled]="zipCode.invalid || nickname.invalid || (walletType == 'card' && (cardErr.checkname.flag || cardErr.ccnumber.flag || cardErr.ccexp.flag || cardErr.cvv.flag)) || (walletType == 'bank' && (cardErr.checkname.flag || cardErr.checkaba.flag || cardErr.checkaccount.flag))" type="submit">
                    Save to Wallet
                </button>
                <div class="btn submit-button" *ngIf="onSubmitLoader">
                    <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
                    <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
                    <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
                </div>
            </div>
        </form>
    </div>
</div>


<div id="keypadWallet" *ngIf="walletType == 'keypad'">
    <div class="header">Enter Card Information</div>
    <div class="accepted-methods">
        <img src="ui/assets/img/VISA.svg" class="accepted-methods-img" />
        <img src="ui/assets/img/Mastercard.svg" class="accepted-methods-img" />
        <img src="ui/assets/img/Discover.svg" class="accepted-methods-img" />
        <img src="ui/assets/img/American Express.svg" class="accepted-methods-img"/>
    </div>
    <div class="clearfix"></div>
    <div class="card-detail-div">
        <form class="add-card">
            <div class="form-group">
                <div class="label" [ngClass]="keypadCardName.invalid && keypadCardName.touched ? 'text-danger' : 'label control-label'">
                    Name on Card
                </div>
                <div class="form-field-custom">
                    <input name="name-on-card" class="form-field-collect-js form-field" placeholder="Name on Card"
                           minlength="4" maxlength="100" [(ngModel)]="wallet.name" #keypadCardName="ngModel" required
                           pattern="^(?! )[A-Za-z0-9 ]+(?<! )$" [ngClass]="{'is-invalid': keypadCardName.invalid && keypadCardName.touched}">
                </div>
                <div *ngIf="keypadCardName.invalid && keypadCardName.touched" class="invalid-feedback">
                    <div *ngIf="keypadCardName.errors?.pattern">Invalid Name on Card</div>
                    <div *ngIf="keypadCardName.errors?.minlength">Minimum length is 4 characters</div>
                    <div *ngIf="keypadCardName.errors?.maxlength">Maximum length is 100 characters</div>
                </div>
            </div>

            <div class="form-group">
                <div class="label" [ngClass]="keypadInput.invalid && keypadInput.touched ? 'text-danger' : 'label control-label'">
                    Keypad Input
                </div>
                <div [hidden]="keypadDataLocked">
                    <div class="form-field-custom">
                        <input name="keypad-data" class="form-field" type="password" minlength="160" maxlength="160"
                               [(ngModel)]="wallet.tokenId" #keypadInput="ngModel" required
                               [ngClass]="{'is-invalid': keypadInput.invalid && keypadInput.touched}"
                               (keydown.enter)="lockKeypadDataFieldIfInputValid()" placeholder="****************">
                    </div>
                    <div *ngIf="keypadInput.invalid && keypadInput.touched" class="invalid-feedback">
                        <div *ngIf="keypadInput.errors?.required">Keypad Input is required</div>
                        <div *ngIf="keypadInput.errors?.minlength">Invalid Keypad Input - Clear and Re-enter</div>
                        <div *ngIf="keypadInput.errors?.maxlength">Invalid Keypad Input - Clear and Re-enter</div>
                    </div>
                </div>
                <div [hidden]="!keypadDataLocked" class="success-text">
                    CAPTURED SUCCESSFULLY
                </div>
            </div>
            <div class="form-group">
                <div class="label" [ngClass]="keypadZipCode.invalid && keypadZipCode.touched ? 'text-danger' : 'label control-label'">
                    ZIP Code
                </div>
                <div class="form-field-custom">
                    <input name="billing-postal" class="form-field-collect-js form-field" placeholder="00000"
                           minlength="5" maxlength="7" [(ngModel)]="wallet.zipCode" #keypadZipCode="ngModel" required
                           [ngClass]="{'is-invalid': keypadZipCode.invalid && keypadZipCode.touched}"
                           pattern="^(?! )[A-Za-z0-9 ]+(?<! )$" [disabled]="isDisabled">
                </div>
                <div *ngIf="keypadZipCode.invalid && keypadZipCode.touched"
                     class="invalid-feedback">
                    <div *ngIf="keypadZipCode.errors?.required">ZIP Code is required</div>
                    <div *ngIf="keypadZipCode.errors?.pattern">Invalid ZIP Code</div>
                    <div *ngIf="keypadZipCode.errors?.minlength">Minimum length is 5 digits</div>
                    <div *ngIf="keypadZipCode.errors?.maxlength">Maximum length is 7 digits</div>
                </div>
            </div>
            <div class="input-flex">
                <div class="form-group bottom-m-br">
                    <div class="label"
                         [ngClass]="keypadNickname.invalid && keypadNickname.touched ? 'text-danger' : 'label control-label'">
                        Payment Method Nickname
                    </div>
                    <div class="form-field-custom">
                        <input name="nickname" class="form-field-collect-js form-field" minlength="1" maxlength="20"
                               [(ngModel)]="wallet.nickname" #keypadNickname="ngModel" pattern="^(?! )[A-Za-z0-9 ]+(?<! )$"
                               placeholder="Nickname" required>
                    </div>
                    <div *ngIf="keypadNickname.invalid && keypadNickname.touched"
                         class="invalid-feedback" style="display: block">
                        <div *ngIf="keypadNickname.errors.required">Payment Method Nickname is required</div>
                        <div *ngIf="keypadNickname.errors?.pattern">Invalid Nickname</div>
                        <div *ngIf="keypadNickname.errors?.minlength">Minimum length of 1 character</div>
                        <div *ngIf="keypadNickname.errors?.maxlength">Maximum length of 20 characters</div>
                    </div>
                </div>
            </div>
            <div class="sub-div">
                <div class="back-button" (click)="toggleWallet('back');">
                    <i class="fas fa-chevron-left"></i>
                </div>
                <button *ngIf="!onSubmitLoader" (click)="displayLoadingImage(); handleKeypadSubmission();" class="btn submit-button" [disabled]="keypadCardName.invalid || keypadInput.invalid || keypadZipCode.invalid || keypadNickname.invalid" type="submit">
                    Save to Wallet
                </button>
                <div class="btn submit-button" *ngIf="onSubmitLoader">
                    <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
                    <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
                    <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
                </div>
            </div>
        </form>
    </div>
</div>

<div id="autopayplan" *ngIf="currentStep === 1 && currentButton !== -1">
    <form class="frm-card" #formPaymentPlansSetup="ngForm" novalidate>
        <img src="ui/assets/img/Line_Recurring_Step1.svg" class="tracker-img"/>
        <div class="header">{{LABEL_PLAN}} Setup</div>
        <div class="setup-details" [hidden]="currentButton === 2">
            Autopay rules automatically process payments when new statements or invoices are created.
            The payment date will determine when the automatic payment will process.
            By default, an autopay rule covers the entire amount of the document, unless a max payment limit is specified.
            <b><u>If you have a current balance on your account, the creation of an autopay rule will not automatically pay that balance.</u></b>
        </div>
        <div class="setup-details" [hidden]="currentButton === 1">
            A payment plan allows a company to consistently collect a set payment amount by the selected frequency. 
            A payment plan could be utilized to collect a large balance due from a customer but divided into smaller payments. 
        </div>
        <div class="clearfix"></div>
        <div class="select-div">
            <div class="left-label"
                 [ngClass]="[ formPaymentPlanSubmitted && account.invalid || account.invalid && (account.dirty || account.touched)? 'text-danger' : 'label control-label']">
                {{LABEL_CUSTOMER}}
            </div>
            <select name="account" class="right-select" [(ngModel)]="paymentPlan.accountObj" [disabled]="isEditing"
                    #account="ngModel" account required>
                <option *ngIf="accounts.length>1" value="null">
                    Please Select
                </option>
                <option *ngFor="let account of accounts" [ngValue]="account"
                        [selected]="isEditing ? paymentPlan.accountObj.sid  === account.sid : null"
                        [hidden]="isEditing ? false : !account.allowNew" [disabled]="!account.allowNew">
                    {{account.accountName}} - {{account.accountNumber}}
                </option>
            </select>
            <div class="question-mark"><i class="fas fa-question-circle" aria-hidden="true" [ngbTooltip]="getAccountTooltip()" placement="left"></i></div>
            <div *ngIf="formPaymentPlanSubmitted && account.invalid || account.invalid && (account.dirty || account.touched)"
                class="invalid-feedback">
                <div *ngIf="account.errors.required">Account is required</div>
            </div>
        </div>
        <div class="clearfix"></div>
        <div class="select-div">
            <div class="left-label"
                [ngClass]="[ (formPaymentPlanSubmitted && frequency.invalid) || frequency.invalid && (frequency.dirty || frequency.touched)? 'text-danger' : 'label control-label']">
                {{LABEL_PAYMENT_FREQUENCY}}
            </div>
            <select name="frequency" class="right-select" [(ngModel)]="paymentPlan.frequencyObj" #frequency="ngModel"
                frequency required>
                <option *ngIf="frequencies.length>1" value="null">
                    Please Select
                </option>
                <option *ngFor="let frequency of frequencies" [ngValue]="frequency"
                    [selected]="isEditing && paymentPlan.frequencyObj ? paymentPlan.frequencyObj.sid  === frequency.sid: null">
                    {{frequency.caption}}
                </option>
            </select>
            <div class="question-mark"><i class="fas fa-question-circle" aria-hidden="true" [ngbTooltip]="getFrequencyTooltip()" placement="left"></i></div>
            <div *ngIf="formPaymentPlanSubmitted && frequency.invalid || frequency.invalid && (frequency.dirty || frequency.touched)"
                class="invalid-feedback">
                <div *ngIf="frequency.errors.required">{{LABEL_PAYMENT_FREQUENCY}} is required</div>
            </div>
        </div>
        <div class="clearfix"></div>
        <div class="select-div">
            <div class="left-label"
                [ngClass]="[ formPaymentPlanSubmitted && endEvent.invalid || endEvent.invalid && (endEvent.dirty || endEvent.touched)? 'text-danger' : 'label control-label']">
                End Event
            </div>
            <select name="selectMeauto" class="right-select" id="selectMeauto"
                [(ngModel)]="paymentPlan.event.endEventObj" (ngModelChange)="onEventChange()" #endEvent="ngModel"
                endEvent required>
                <option *ngIf="events.length>1" value="null">
                    Please Select
                </option>
                <option *ngFor="let event of events" [ngValue]="event">
                    {{event.label}}
                </option>
            </select>
            <div class="question-mark"><i class="fas fa-question-circle" aria-hidden="true" [ngbTooltip]="getEndEventTooltip()" placement="left"></i></div>
            <div *ngIf="formPaymentPlanSubmitted && endEvent.invalid || endEvent.invalid && (endEvent.dirty || endEvent.touched)"
                class="invalid-feedback">
                <div *ngIf="endEvent.errors.required">End Event is required</div>
            </div>
        </div>
        <div class="clearfix"></div>
        <div id="autobyDate" class="group" *ngIf="paymentPlan.event.endEvent !== -1">
            <div class="input-flex">
                <div class="form-group">
                    <div class="left-label label control-label"
                        [ngClass]="[ formPaymentPlanSubmitted && startDate.invalid || startDate.invalid && (startDate.dirty || startDate.touched)? 'text-danger' : 'label control-label']">
                        Start Date
                    </div>
                    <div role="wrapper" class="gj-datepicker gj-datepicker-bootstrap gj-unselectable input-group form-date-input">
                        <input name="startDate" class="form-input-date datepicker5 form-control" required=""
                            data-type="datepicker" data-guid="a96b7ab2-a8de-83a5-20d7-753ed1abffb5"
                            data-datepicker="true" role="input" [(ngModel)]="paymentPlan.event.startDate" 
                               [minDate]="tomorrowDate" ngbDatepicker
                            #startDate="ngModel"  #ds="ngbDatepicker"
                            [maxDate]="paymentPlan.event.endEvent === 0 ? paymentPlan.event.endDate: null">
                        <span
                            class="input-group-append" role="right-icon">
                            <button class="btn btn-outline-secondary border-left-0" type="button" (click)="ds.toggle()"
                                (blur)="paymentPlan.event.endEvent === 0 && validateEndDate(paymentPlan);"
                                type="button">
                                <i class="fa fa-calendar"></i>
                            </button>
                        </span>
                    </div>
                    <div *ngIf="formPaymentPlanSubmitted && startDate.invalid || startDate.invalid && (startDate.dirty || startDate.touched)"
                        class="invalid-feedback">
                        <div *ngIf="startDate.errors.required">Start Date is required</div>
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>
            <div class="input-flex" *ngIf="paymentPlan.event.endEvent === 0">
                <div class="form-group" >
                    <div class="left-label label control-label"
                        [ngClass]="[ formPaymentPlanSubmitted && endDate.invalid || endDate.invalid && (endDate.dirty || endDate.touched)? 'text-danger' : 'label control-label']">
                        End Date
                    </div>
                    <div role="wrapper" class="gj-datepicker gj-datepicker-bootstrap gj-unselectable input-group form-date-input">
                        <input name="endDate" class="form-input-date datepicker6 form-control" required=""
                            data-type="datepicker" data-guid="b9334073-04b2-0c77-b230-74fe0ebc2837"
                            data-datepicker="true" role="input" [(ngModel)]="paymentPlan.event.endDate" ngbDatepicker
                            #endDate="ngModel" #de="ngbDatepicker" [minDate]="paymentPlan.event.startDate">
                        <span class="input-group-append" role="right-icon">
                            <button class="btn btn-outline-secondary border-left-0" type="button" (click)="de.toggle()"
                                (blur)="paymentPlan.event.endEvent === 0 && validateEndDate(paymentPlan);">
                                <i class="fa fa-calendar"></i>
                            </button>
                        </span>
                    </div>
                    <div *ngIf="formPaymentPlanSubmitted && endDate.invalid || endDate.invalid && (endDate.dirty || endDate.touched)"
                        class="invalid-feedback">
                        <div *ngIf="endDate.errors.required">End Date is required</div>
                        <div *ngIf="endDateValidation">End Date should be greater or equal to start date</div>
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>
            <div class="input-flex" *ngIf="paymentPlan.event.endEvent === 1">
                <div class="form-group">
                    <div class="left-label label control-label"
                        [ngClass]="[ formPaymentPlanSubmitted && noOfPayment.invalid || noOfPayment.invalid && (noOfPayment.dirty || noOfPayment.touched)? 'text-danger' : 'label control-label']">
                        Number of Payments</div>
                    <input name="noOfPayment" class="right-select" type="number" placeholder="1" numberonly required min="1"
                        [(ngModel)]="paymentPlan.event.numberOfPayment" #noOfPayment="ngModel">
                    <div *ngIf="(formPaymentPlanSubmitted && noOfPayment.invalid) || (noOfPayment.invalid) && (noOfPayment.dirty || noOfPayment.touched)
                        || paymentPlan.event.numberOfPayment < 1"
                        class="invalid-feedback">
                        <div *ngIf="paymentPlan.event.numberOfPayment < 1">Number must be greater than zero.</div>
                        <div *ngIf="paymentPlanAmount.errors.required">Missing Number of Payments.</div>
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>
            <div class="input-flex"  *ngIf="!paymentHubComponent?.defaultSettings?.settings.requireFullAutopay" [hidden]="currentButton === 2">
                <div class="form-group">
                    <div class="left-label label control-label">
                        Pay in Full 
                    </div>
                    <input type="checkbox" name="paymentIsFull" class="right-select"
                            [(ngModel)]="paymentPlan.paymentIsFull" #paymentIsFull="ngModel" (change)="paymentPlan.amount= ''"
                            [required]="!paymentPlan.amount">
                </div>
            </div>
            <div class="clearfix"></div>
            <div class="input-flex" [hidden]="currentButton === 1 && paymentPlan.paymentIsFull">
                <div class="form-group">
                    <div class="left-label label control-label"
                        [ngClass]="[ (formPaymentPlanSubmitted && !paymentPlan.paymentIsFull && paymentPlanAmount.invalid) && (paymentPlanAmount.dirty || paymentPlanAmount.touched)? 'text-danger' : 'label control-label']">
                        {{LABEL_PAYMENT_LIMIT}}</div>
                    <input name="paymentPlanAmount currency" class="right-select" type="text" placeholder="0.00"
                        currencyMask [options]="{ align: 'center', prefix: '$ ', thousands: ',', decimal: '.' }"  
                        [required]="!paymentPlan.paymentIsFull" [(ngModel)]="paymentPlan.amount"
                        [disabled]="paymentPlan.paymentIsFull" #paymentPlanAmount="ngModel" min="0">
                    <div *ngIf="(formPaymentPlanSubmitted && !paymentPlan.paymentIsFull && paymentPlanAmount.invalid) || (!paymentPlan.paymentIsFull && paymentPlanAmount.invalid) && (paymentPlanAmount.dirty || paymentPlanAmount.touched)"
                        class="invalid-feedback">
                        <div *ngIf="paymentPlanAmount.errors.required">{{LABEL_PAYMENT_LIMIT}} is required</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="clearfix"></div>
        <div class="sub-div">
            <div class="back-button back1">
                <i class="fas fa-chevron-left" (click)=toggleButton(-1,0) aria-hidden="true"></i>
            </div>
            <button class="btn submit-button continue-btn2"
                (click)="formPaymentPlanSubmitted = true; formPaymentPlansSetup.form.valid  &&
                (paymentPlan.event.endEvent !== 1 || paymentPlan.event.numberOfPayment > 0 ) && toggleStep(2)"
                type="button">
                Continue
            </button>
        </div>
        <div class="clearfix"></div>
    </form>
</div>

<div id="payment-method" *ngIf="currentStep === 2">
    <form class="frm-card" #formPaymentPlansSetup="ngForm" novalidate>
        <div class="add-method-div saved-method">
            <img src="ui/assets/img/Line_Recurring_Step2.svg" class="tracker-img"/>
            <br *ngIf="wallets.length > 0"/>
            <br *ngIf="wallets.length > 0"/>
            <div *ngIf="wallets.length > 0" class="header">Select a Saved Payment Method</div>
            <div class="clearfix"></div>
            <div> 
                <div *ngIf="wallets.length > 0">
                    <div class="float-left">
                        <img src="ui/assets/img/Wallet_Selection.svg" class="wallet-icon">
                    </div>
                    <div class="left-header float-left">Wallet</div>
                    <div class="float-left wallet-select">
                        <select name="walletT" class="right-select-wallet" [(ngModel)]="paymentPlan.wallet.walletObj"
                            [required]= "(selectedPaymentMethod == '' || selectedPaymentMethod == 'wallet') ? true : null" (change)="changePaymentMethod('wallet')">
                            <option [selected]="true" value="">Select a Saved Payment Method</option>
                            <option *ngFor="let wallet of wallets" [ngValue]="wallet" >
                                {{wallet.nickname}}
                                {{wallet.ccNumber}}
                                {{wallet.accountNumber}}
                            </option>
                        </select>
                    </div>
                    <div class="clearfix"></div>
                </div>

                <div *ngIf="wallets.length > 0" class="header border-top-green">Or Use New Payment Method</div>
                <div *ngIf="wallets.length == 0" class="header">Select Payment Method</div>

                <div class="input-flex">
                    <div class="add-card-button wd-50 card-detail" [hidden]="!paymentHubComponent?.defaultSettings?.settings.acceptCards" [ngClass]="[(selectedPaymentMethod == 'card' || selectedPaymentMethod == 'keypad') ? 'active-card-btn' : '']" (click)="changePaymentMethod(paymentHubComponent.adminUserWithKeypadEnabled() ? 'keypad' : 'card')">
                        <img src="ui/assets/img/CreditDebit_Selection.svg" class="cc-ach-icons"/>
                        <div>Credit or Debit Card</div>
                    </div>
                    <div class="add-card-button wd-50 account-detail" [hidden]="!paymentHubComponent?.defaultSettings?.settings.acceptChecks" [ngClass]="[selectedPaymentMethod == 'bank' ? 'active-card-btn' : '']" (click)="changePaymentMethod('bank')">
                        <img src="ui/assets/img/BankAccount_Selection.svg" class="cc-ach-icons"/>
                        <div>Checking Account</div>
                    </div>
                </div>
                <div *ngIf="wallets.length == 0 && formPaymentPlanPaySubmitted && selectedPaymentMethod == ''"
                    class="invalid-feedback">Please Select a Payment Method.
                </div>
            </div>
        </div>
        <div class="sub-div">
            <div class="back-button back1">
                <i class="fas fa-chevron-left" (click)=toggleStep(1) aria-hidden="true"></i>
            </div>
            <button class="btn submit-button continue-btn2"
                (click)="formPaymentPlanPaySubmitted = true; formPaymentPlansSetup.form.valid && selectedPaymentMethod &&
                 selectPaymentMethod()"
                type="button">
                Continue
            </button>
        </div>
        <div class="clearfix"></div>
    </form>
</div>

<div id="autoreview" *ngIf="currentStep === 3">
    <form class="frm-card" #formReviewPaymentPlan="ngForm" novalidate>
        <img src="ui/assets/img/Line_Recurring_Step4.svg" class="tracker-img"/>
        <div class="header">Review {{currentButton === 1 ? "Autopay Rule" : "Payment Plan"}}</div>
        <table class="line-table">
            <tbody>
                <tr>
                    <th>Account#</th>
                    <th>Payment Frequency</th>
                    <th>Start Date</th>
                    <th *ngIf="paymentPlan.event.endEventObj.id === 0">End Date</th>
                    <th *ngIf="paymentPlan.event.endEventObj.id === 1">Number of Payments</th>
                    <th *ngIf="paymentPlan.event.endEventObj.id === 2">Expires</th>
                </tr>
                <tr>
                    <td>{{paymentPlan.accountObj.accountName}} <br />{{paymentPlan.accountObj.accountNumber}}</td>
                    <td>{{paymentPlan.frequencyObj.caption}}</td>
                    <td>{{paymentPlan.event.startDate | dateFormatter | date:'MM/dd/yyyy' }}</td>
                    <td *ngIf="paymentPlan.event.endEventObj.id === 0">
                        {{paymentPlan.event.endDate |  dateFormatter | date:'MM/dd/yyyy'}}</td>
                    <td *ngIf="paymentPlan.event.endEventObj.id === 1">
                        {{paymentPlan.event.numberOfPayment | number : '1.0-0'}}</td>
                    <td *ngIf="paymentPlan.event.endEventObj.id === 2">
                        Never</td>
                </tr>
            </tbody>
        </table>
        <div class="paymthod-strip background-highlight">
            <div class="align-left">Payment Method</div>
            <div class="align-right">
                <div>{{paymentMethod}}</div>
                <div>{{paymentMethod2}}</div>
            </div>
        </div>
        <div class="paymthod-strip background-highlight" *ngIf="paymentPlan.amount && paymentPlan.amount!='0'">
            <div class="align-left">Payment Limit</div>
            <div class="align-right">{{paymentPlan.amount | currency}}</div>
        </div>
        <br/>
        <div class="fill-details">
            Enter your email or phone number to receive confirmation details for your recurring payment
            rule.
        </div>
        <div class="input-flex">
            <div class="form-group">
                <div class="label"
                    [ngClass]="[ formReviewPaymentPlanSubmitted && email.invalid || email.invalid && (email.dirty || email.touched)? 'text-danger' : 'label']">
                    Email Address
                </div>
                <div class="form-field-custom">
                    <input name="email" class="form-field" type="email"
                        [(ngModel)]="paymentPlan.contact.email" #email="ngModel" [required]="!isCCpayment"
                        pattern="[a-z0-9A-Z._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}\s*">
                </div>
                <div *ngIf="formReviewPaymentPlanSubmitted && email.invalid || email.invalid && (email.dirty || email.touched)"
                    class="invalid-feedback">
                    <div *ngIf="email.errors.required">Email address is required when creating a payment rule with a bank account</div>
                    <div *ngIf="email.errors.pattern">Invalid Email Address</div>
                </div>
            </div>
            <div class="form-group">
                <div class="label">Cellphone Number</div>
                <div class="form-field-custom">
                    <input name="phoneNumber" class="form-field" appPhoneMask type="tel"
                        [(ngModel)]="paymentPlan.contact.phoneNumber" maxlength="14">
                </div>
                <div *ngIf="formReviewPaymentPlanSubmitted && !validUsPhoneNumber"
                    class="invalid-feedback">
                    <div *ngIf="!validUsPhoneNumber">Invalid Phone Number</div>
                </div>
                <small>SMS charges may apply.</small>
            </div>
        </div>
        <div class="clearfix"></div>
        <br><br><br>
        <div *ngIf="!paymentHubComponent?.defaultSettings?.admin && !isCCpayment && LABEL_PLAN == 'Autopay'" class="fill-details">
            By clicking the Enroll button, I authorize {{paymentHubComponent.defaultSettings.settings.clientName}} to debit my bank account for recurring payments based on when a new bill is available.
        </div>
        <div *ngIf="!paymentHubComponent?.defaultSettings?.admin && !isCCpayment && LABEL_PLAN != 'Autopay'" class="fill-details">
            By clicking the Enroll button, I authorize {{paymentHubComponent.defaultSettings.settings.clientName}} to debit my bank account for recurring payments based on the details above. 
        </div>
        <div *ngIf="paymentHubComponent?.defaultSettings?.admin && !isCCpayment && LABEL_PLAN == 'Autopay'" class="fill-details">
            By clicking the Enroll button, I authorize that {{paymentHubComponent.defaultSettings.settings.clientName}} has received verbal authorization from the customer to debit their bank account for recurring payments based on when a new bill is available.  
        </div>
        <div *ngIf="paymentHubComponent?.defaultSettings?.admin && !isCCpayment && LABEL_PLAN != 'Autopay'" class="fill-details">
            By clicking the Enroll button, I authorize that {{paymentHubComponent.defaultSettings.settings.clientName}} has received verbal authorization from the customer to debit their bank account for recurring payments.  
        </div>
        <div class="sub-div flex bottom-m-br">
            <div class="back-button back2">
                <i class="fas fa-chevron-left" aria-hidden="true" (click)=toggleStep(2)></i>
            </div>
            <div class="terms">
                <input name="agree1" type="checkbox" [(ngModel)]="agree" #agree1="ngModel" required> I agree to the
                <span class="terms-link" (click)="toggleStep(5)">Terms and Conditions</span>
                <div *ngIf="formReviewPaymentPlanSubmitted && agree1.invalid || agree1.invalid && (agree1.dirty || agree1.touched)"
                    class="invalid-feedback">
                    <div *ngIf="agree1.errors.required">Please accept the Terms and Conditions</div>
                </div>
            </div>

            <button *ngIf="!onSubmitLoader" class="btn submit-button Enroll3" 
                (click)="formReviewPaymentPlanSubmitted = true; isValidUsPhoneNumber(paymentPlan.contact.phoneNumber) && formReviewPaymentPlan.form.valid && onEnroll()"
                type="submit">Enroll</button>
            <div class="btn submit-button" *ngIf="onSubmitLoader">
                <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
                <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
                <span class="spinner-grow spinner-grow-lg" role="status" aria-hidden="true"></span>
            </div>
        </div>
    </form>
</div>

<div id="termsConditions" class="termsAndConditions" *ngIf="currentStep === 5">
    <div class="innerTerms" [innerHTML]="LABEL_TERMS"></div>
    <br/>
    <div class="sub-div">
        <button class="btn submit-button submit-pay" (click)="toggleStep(3)">Back</button>
    </div>
</div>

<div id="autoconfirmation" *ngIf="currentStep === 4">
    <div class="header-green">
        {{currentButton === 1 ? "Your Autopay has been created!" : "Your Payment plan has been created!"}}
    </div>
    <div class="header">REVIEW CONFIRMATION DETAILS</div>
    <div class="cofirm-details-group">
        <div class="confirm-details">
            <div class="align-left">Submitted Date:</div>
            <div class="align-right">{{response.currentDate | date:'MM/dd/yyyy'}}</div>
        </div>
        <div class="confirm-details">
            <div class="align-left">Submitted Time:</div>
            <div class="align-right">{{response.currentDate | date:'h:mm a'}}</div>
        </div>
    </div>
    <div class="clearfix"></div>
    <table class="line-table">
        <tbody>
            <tr>
                <th>Account#</th>
                <th>Payment Frequency</th>
                <th>Start Date</th>
                <th *ngIf="paymentPlan.event.endEventObj.id === 0">End Date</th>
                <th *ngIf="paymentPlan.event.endEventObj.id === 1">Number of Payments</th>
                <th *ngIf="paymentPlan.event.endEventObj.id === 2">Expires</th>
            </tr>
            <tr>
                <td>{{paymentPlan.accountObj.accountName}} <br />{{paymentPlan.accountObj.accountNumber}}</td>
                <td>{{paymentPlan.frequencyObj.caption}}</td>
                <td>{{paymentPlan.event.startDate | dateFormatter | date:'MM/dd/yyyy' }}</td>
                <td *ngIf="paymentPlan.event.endEventObj.id === 0">
                    {{paymentPlan.event.endDate |  dateFormatter | date:'MM/dd/yyyy'}}</td>
                <td *ngIf="paymentPlan.event.endEventObj.id === 1">
                    {{paymentPlan.event.numberOfPayment | number : '1.0-0'}}</td>
                <td *ngIf="paymentPlan.event.endEventObj.id === 2">
                    Never</td>
            </tr>
        </tbody>
    </table>
    <br>
    <div class="paymthod-strip background-highlight">
        <div class="align-left">Payment Method</div>
        <div class="align-right">
            {{paymentPlan.wallet.walletObj.nickname}}
            {{paymentPlan.wallet.walletObj.ccNumber}}
            {{paymentPlan.wallet.walletObj.accountNumber}}
        </div>
    </div>
    <div class="paymthod-strip background-highlight" *ngIf="paymentPlan.amount && paymentPlan.amount!='0'">
        <div class="align-left">Payment Limit</div>
        <div class="align-right">{{paymentPlan.amount | currency}}</div>
    </div>
    <div class="input-flex contact-info">
        <div class="form-group">
            <div class="label">Email Address</div>
            <div class="form-field-custom">
                <input class="form-field" readonly type="email" [(ngModel)]="paymentPlan.contact.email">
            </div>
        </div>
        <div class="form-group">
            <div class="label">Phone Number</div>
            <div class="form-field-custom">
                <input class="form-field" readonly type="tel" [(ngModel)]="paymentPlan.contact.phoneNumber">
            </div>
            <small>Charges may apply.</small>
        </div>
    </div>
    <br><br>
    <div class="sub-div">
        <button class="btn submit-button print" (click)=printPage()>Print</button>
        <button class="btn submit-button print" (click)=toggleButton(-1,0)>Done</button>
    </div>
</div>
